export enum CustomerRole {
  ACCOUNT_MANAGER = 'manager',
  AGENT = 'agent',
  CUSTOMER = 'customer',
  ADMIN = 'admin',
}
